import { getClient } from 'sources/api';

export const client = getClient({ decamelizeRequest: true });

export enum Resource {
  Account = '/accounts',
  AuthIntegrations = '/auth_integrations',
  AuthIntegrationsFull = '/auth_integrations/full',
  AuthIntegrationsSessionId = '/auth_integrations/generate_unique_session_id',
  BillingPayments = '/billing/payments',
  BillingStripeApiKey = '/billing/stripe_api_key',
  BillingSubscriptionDefaultPaymentMethod = '/billing/default_payment_method',
  BillingSubscriptionPaymentMethod = '/billing/payment_method',
  BillingSubscriptionPlan = '/billing/stripe_subscription',
  Campus = '/campuses',
  ClassroomLinks = '/classroom_links',
  CreateCheckoutSession = '/billing/create_checkout_session',
  EmailIntegrations = '/email_integrations',
  EmailIntegrationsGmail = '/email_integrations/gmail',
  EventGuests = '/event_guests',
  EventTimeSlots = '/event_time_slots',
  File = '/files',
  GroupKey = '/group_key',
  Groups = '/groups',
  LeadAttrs = '/pnm_attrs',
  LeadDuplicates = '/pnm_duplicates',
  Leads = '/pnms',
  LeadTags = '/pnm_tags',
  Notifications = '/notifications',
  ReportingChapters = '/reporting_chapters',
  StripeProducts = '/products',
  Tasks = '/tasks',
}
